import React, { useEffect, useState } from "react";
import { Divider, Row, Col, Radio, Checkbox } from "antd";

const StepItemWidget = (props) => {
  const { itemInfo, onCheck, isLast, userData, readOnly } = props;
  const isChecked = userData.camper_sel_trip && userData.camper_sel_trip.includes(itemInfo.id);

  return (
    <div style={{ marginBottom: 10 }}>
      <div style={{ fontWeight: 600 }}>
        <div style={{ marginTop: 10, marginBottom: 5 }}>
          <Row align={"top"} justify="space-between" gutter={16}>
            <Col flex="1">
              <Checkbox
                onChange={(e) => {
                  if (!readOnly && onCheck != undefined) {
                    onCheck(itemInfo.id);
                  }
                }}
                checked={isChecked}
                disabled={readOnly}
                style={readOnly ? { pointerEvents: 'none' } : {}}
              >
                {itemInfo.title.split('\\n').map((section, secKey) => {
                  return <div key={secKey}>{section}</div>;
                })}
              </Checkbox>
            </Col>
            <Col flex="none" style={{ textAlign: "right", minWidth: 70 }}>
              ${itemInfo.price}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
export default StepItemWidget;
